<template>
  <div class="app">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12" style="padding-left: 0px; padding-right: 0px;">
                <left-nav></left-nav>
                 <div id="appContainer">
                   <header class="titleRow">
                    <div class="row">
                      <div class="col-sm-9">
                        <h4>Customers / <router-link :to="{name: 'RelationshipsEdit', params: { id: company.id }}">{{ company.name }}</router-link> / <router-link :to="{name: 'RelationshipsAssets', params: { id: company.id }}">Asset</router-link> / {{ asset.name }}</h4>
                      </div>
                      
                      <div class="col-sm-3">
                        <div align="right">
                          <a @click.prevent="deleteAsset()" class="btnRedText">Delete Asset</a>&nbsp; 
                          <router-link :to="{name: 'AssetsEdit', params: { id: $route.params.id }}" class="btnGreenLineHeader" style="margin-top: -3px;">Edit Asset</router-link>
                        </div>
                      </div>
                      
                    </div>
                  </header>
                  <edit-asset></edit-asset>
                 </div>
             </div>
        </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import LeftNav from '@/components/nav/Relationships.vue'
import EditAsset from '@/views/assets/Edit.vue'

import axios from 'axios'

export default {
  // name: 'Home',
  components: {
    LeftNav,
    EditAsset
  },
  data () {
    return {
      company: {},
      asset: {},
    }
  },
  methods: {
    deleteAsset () {
      if(confirm("Do you really want to delete this asset?")){
        axios
          .delete(`/api/assets/${this.$route.params.id}`)
          .then(response => (
            this.$toast.success("Asset deleted", {}),
            this.$router.push({ name: 'RelationshipsAssets', params: { id: this.asset.company_id } })
          ))
          .catch(err => console.log(err))
          // .finally(() => this.loading = false)
      }
    }
  },
  created () {
    axios
      .get(`/api/assets/${this.$route.params.id}`)
      .then((res) => {
        this.asset = res.data

        axios
          .get(`/api/companies/${this.asset.company_id}`)
          .then((res) => {
            this.company = res.data
          })

      })
  }
}
</script>
